import { render, staticRenderFns } from "./import-sales-order-request.vue?vue&type=template&id=63c1845f&"
import script from "./import-sales-order-request.vue?vue&type=script&lang=ts&"
export * from "./import-sales-order-request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports